module.exports = __webpack_public_path__ + "img/customer_report.a94a9cfb.png";